import { Button } from '@duxton-web/ui';
import ErrorFallbackSVG from '@assets/images/insight/error-fallback.svg';
import Header from '../Header';
import { useTranslation } from 'react-i18next';

const ErrorFallback: React.FC = () => {
  const { t } = useTranslation();
  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex h-screen flex-col">
      <Header />
      <div className="flex flex-1 flex-col items-center justify-center">
        <div className="mb-4">
          <ErrorFallbackSVG />
        </div>
        <div className="mb-6 text-xl/7 font-semibold">{t('heading_something_went_wrong', 'Something went wrong')}</div>
        <Button type="primary" size="small" onClick={handleReload}>
          {t('dna_crm_body_reloadPage', 'Reload page')}
        </Button>
      </div>
    </div>
  );
};

export default ErrorFallback;
